/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** AI sparkle (16×16 Figma tile menu). Color via `currentColor`. */
const SparkleIcon = ({
  size = 16,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M8 2.5L8.9 6.1L12.5 7L8.9 7.9L8 11.5L7.1 7.9L3.5 7L7.1 6.1L8 2.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M13 3V3.75M13.75 4.75H14.5M13 6.5V7.25M11.25 4.75H10.5"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M3 10V10.75M3.75 11.75H4.5M3 13.5V14.25M1.25 11.75H0.5"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

SparkleIcon.propTypes = iconPropTypes;

export default SparkleIcon;
